// extracted by mini-css-extract-plugin
module.exports = {"headingText":"SectionHeadingStyles_headingText__2uP91","heading":"SectionHeadingStyles_heading__3Yeja","backIcon":"SectionHeadingStyles_backIcon__3PXey"};